import { inject, Injectable, Injector } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, firstValueFrom, Observable, Subject, tap } from "rxjs";

export interface Runtime {
  "x-ibm-client-id": string;
  apiUrl: string;
}

export interface IdpConfig {
  clientId: string;
  "openid-configuration": string;
  introspection_endpoint: string;
  end_session_endpoint: string;
  revocation_endpoint: string;
  scopes: string;
  check_session_iframe: string;
  issuer: string;
  token_endpoint: string;
  authorization_endpoint: string;
  userinfo_endpoint: string;
}

@Injectable({
  providedIn: "root",
})
export class RuntimeConfigService {
  private injector = inject(Injector);

  public runtimeConfig: Runtime;
  public iDPConfig: IdpConfig;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  loadRuntimeConfig(): void {
    const http = this.injector.get(HttpClient);
    http
      .get<Runtime>("/config/runtime-config.json", {
        headers: { "X-Skip-AuthInterceptor": "yes" },
      })
      .pipe(
        tap((data) => {
          this.runtimeConfig = data;
        }),
        catchError((err) => {
          this.runtimeConfig = null;
          return err;
        })
      )
      .subscribe();
  }

  loadIDPConfig(): void {
    const http = this.injector.get(HttpClient);

    http
      .get<IdpConfig>("/config/idpClientNonSecretDetails.json", {
        headers: { "X-Skip-AuthInterceptor": "yes" },
      })
      .pipe(
        tap((data) => {
          this.iDPConfig = data;
        }),
        catchError((err) => {
          this.iDPConfig = null;
          return err;
        })
      )
      .subscribe();
  }

  get config(): Runtime {
    return this.runtimeConfig;
  }

  get IDPconfig(): IdpConfig {
    return this.iDPConfig;
  }
}
